const APP_TENANT_SET = 'APP_TENANT_SET'

export const setTenant = payload => ({
  type: APP_TENANT_SET,
  payload,
})

const initialState = {
  tenant: undefined,
  language: 'en',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case APP_TENANT_SET:
      return {
        ...state,
        tenant: action.payload,
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/redux/modules/settings.ts